// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.topBar {
  padding: 0.25rem 0;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
}
.topBar .walletDetails {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 8px;
  border: 1px solid var(--Stroke);
  color: var(--TextColor);
  cursor: pointer;
  position: relative;
}
.topBar .walletDetails:hover, .topBar .walletDetails.Active {
  background-color: var(--Hover);
}
.topBar .walletDetailsContainer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: absolute;
  top: 4rem;
  right: 5rem;
  background-color: var(--Foreground);
  z-index: 11;
  width: max-content;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0rem 0rem 0.5rem var(--Stroke);
}
.topBar .walletDetailsContainer:after {
  content: "";
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  border-left: 0.8rem solid transparent;
  border-right: 0.8rem solid transparent;
  border-bottom: 1.2rem solid var(--Foreground);
  top: -1rem;
  right: 40%;
  z-index: 10;
}
.topBar .walletDetailsContainer .section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4rem;
}
.topBar .walletDetailsContainer .section.Active {
  border: 1px solid var(--Stroke);
  padding: 0.5rem;
  border-radius: 8px;
}
.topBar .walletDetailsContainer .section .subSection {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  color: var(--TextColor);
}
.topBar .walletDetailsContainer .section .subSection .walletDetailsTitle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  font-weight: 600;
}
.topBar .walletDetailsContainer .section .subSection .walletBalance {
  font-size: 1.6rem;
}
.topBar .walletDetailsContainer .section .subSection .walletBtnPrimary {
  background-color: var(--AccentColor);
  color: #ffffff;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
}
.topBar .walletDetailsContainer .section .subSection .walletBtnSecondary {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--Background);
  color: var(--TextColor);
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
}
.topBar .walletDetailsContainer .section .subSection .balanceTitle {
  font-size: 0.8rem;
  font-weight: 600;
}
.topBar .walletDetailsContainer .section .subSection .balanceMessage {
  font-size: 0.6rem;
  color: var(--TextColor);
  opacity: 0.8;
}
.topBar .walletDetailsContainer .section .balanceContainer {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  color: var(--TextColor);
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceNonEdit {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.125rem 1rem 0.125rem 0.25rem;
  font-size: 1.4rem;
  width: 10rem;
  height: 1.8rem;
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceNonEdit .balance {
  max-width: 8rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceNonEdit.Active {
  animation: move-down 0.2s;
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceNonEdit svg {
  cursor: pointer;
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceForm .lowBalanceInputWrapper {
  position: relative;
  font-size: 1.4rem;
  width: 10rem;
  animation: move-up 0.2s;
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceForm .lowBalanceInputWrapper::after {
  content: "₹";
  position: absolute;
  top: 0;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceForm .lowBalanceInputWrapper .lowBalanceInput {
  width: inherit;
  padding-left: 1rem;
  background: none;
  border: none;
  border-bottom: 0.0625rem solid #9b9b9b;
  border-radius: none;
  position: relative;
  color: var(--TextColor);
  font-size: inherit;
  font-family: inherit;
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceForm .lowBalanceButtonWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transform: translateY(0.3rem);
  animation: fade-in 0.2s;
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceForm .lowBalanceButtonWrapper .cancelBtn {
  padding: 0.2rem 0.8rem;
  background-color: var(--Invitation);
  color: var(--TextColor);
  font-size: 0.8rem;
  border-radius: 4px;
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceForm .lowBalanceButtonWrapper .saveBtn {
  padding: 0.2rem 0.8rem;
  background-color: var(--AccentColor);
  color: #ffffff;
  font-size: 0.8rem;
  border-radius: 4px;
}
.topBar .walletDetailsContainer .section .balanceContainer .lowBalanceForm .lowBalanceButtonWrapper .saveBtn .loading {
  padding: 1px 0.5rem;
}
.topBar .notificationSvg {
  position: relative;
  width: max-content;
  height: max-content;
}
.topBar .notificationSvg div {
  position: absolute;
  padding: 0.25rem;
  background-color: rgb(246, 40, 40);
  top: 0;
  right: 50%;
  font-size: 0.5rem;
  width: 1.25rem;
  height: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 50%;
}
.topBar .SideBarIcon {
  display: none;
  width: 2.5rem;
  height: 2.5rem;
  min-width: 2rem;
  min-height: 2rem;
  border-radius: 50%;
  background: var(--Foreground);
  font-size: 1.5rem;
  font-weight: 1000;
  color: var(--TextColor);
  -webkit-user-select: none;
          user-select: none;
}
.topBar h1 {
  flex: 1 1 8rem;
  color: var(--TextColor);
  font-size: 1.5rem;
}
.topBar .searchBar {
  display: flex;
  align-items: center;
  flex-wrap: wrap-reverse;
  justify-content: flex-end;
  gap: 0.9rem;
}
.topBar .searchBar .searchBarForm {
  background-color: var(--Foreground);
  border-radius: 1.25rem;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  padding: 0 0.75rem;
  position: relative;
  /* Dropdown container */
}
.topBar .searchBar .searchBarForm input {
  background-color: transparent;
  height: 100%;
  outline: none;
  border: none;
  color: var(--TextColor);
  font-size: 0.875rem;
}
.topBar .searchBar .searchBarForm svg {
  margin-top: 0.25rem;
}
.topBar .searchBar .searchBarForm input::placeholder {
  color: #696969;
}
.topBar .searchBar .searchBarForm .search-dropdown {
  position: absolute;
  top: calc(100% + 0.25rem);
  left: 0;
  right: 0;
  padding: 0.5rem;
  background-color: var(--Foreground);
  box-shadow: 0 0 2rem 0 var(--Background);
  border-radius: 1rem;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-height: 20rem;
  overflow: auto;
  z-index: 1000;
}
.topBar .searchBar .searchBarForm .search-dropdown .dropdown-item {
  padding: 0.25rem 0.75rem;
  min-height: 2rem;
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  cursor: pointer;
  color: var(--TextColor);
  transition: background-color 0.2s ease;
}
.topBar .searchBar .searchBarForm .search-dropdown .dropdown-item:hover {
  background-color: var(--Hover);
}
.topBar .searchBar .HalfLogo {
  display: none;
}
.topBar .WalletModal {
  position: absolute;
  top: -1rem;
  right: -14rem;
  z-index: 11;
  display: flex;
  justify-content: flex-end;
}
.topBar .WalletModal .SubWalletModal {
  position: relative;
  top: 4rem;
  right: 3rem;
  height: max-content;
  background: white;
  border-radius: 0.625rem;
  padding: 0.5rem;
  border: 0.025rem solid var(--Stroke);
  display: flex;
  flex-direction: column;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain {
  display: flex;
  padding: 0.5rem;
  gap: 0.5rem;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletImage {
  width: 12.5rem;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletImage .WalletImg {
  display: flex;
  align-items: center;
  padding: 0.25rem;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletImage .WalletImg .yourwallet {
  font-size: 1rem;
  font-weight: 700;
  padding-left: 0.5rem;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletImage .WalletRupees {
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletImage .WalletRupees .WalletNum {
  font-weight: 700;
  font-size: 1.5rem;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletMainButton {
  background-color: #cb1c1c;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  width: 12.5rem;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletMainButton .WalletButton {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletMainButton .WalletButton .RechargeButton {
  width: 10rem;
  padding: 0.5rem;
  background: var(--AccentColor);
  color: #ffffff;
  font-size: 0.8rem;
  border-radius: 0.25rem;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletMainButton .WalletButton .MoreImg {
  width: 10rem;
  padding: 0.25rem;
  display: flex;
  background: #f4f3f8;
  justify-content: center;
  align-items: center;
  margin-top: 0.5rem;
  border-radius: 0.25rem;
  gap: 0.25rem;
}
.topBar .WalletModal .SubWalletModal .WalletImgMain .WalletMainButton .WalletButton .MoreImg .More {
  color: var(--AccentColor);
  font-size: 0.8rem;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain {
  display: flex;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.625rem;
  padding: 0.625rem;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowBalance .LowBalanceAlert {
  font-size: 1.25rem;
  font-weight: 700;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowBalance .FundBalance {
  font-size: 0.75rem;
  color: #9b9b9b;
  text-wrap: balance;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowRupees {
  display: flex;
  justify-content: center;
  align-items: center;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowRupees .LowAlertRupees {
  font-size: 1.75rem;
  font-weight: 700;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowRupeesInput {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowRupeesInput .RupeesInput {
  padding: 0.5rem;
  border: 0.0625rem solid var(--Invitation);
  border-radius: 0.625rem;
  display: flex;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowRupeesInput .RupeesInput input {
  width: 100%;
  border: none;
  border-bottom: 0.0625rem solid var(--Invitation);
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowRupeesInput .SaveRupeesButton {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowRupeesInput .SaveRupeesButton .RupeesCancel {
  width: 5rem;
  height: 2rem;
  font-size: 0.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--Invitation);
  padding: 0.25rem;
  border-radius: 0.25rem;
}
.topBar .WalletModal .SubWalletModal .LowBalanceMain .LowRupeesInput .SaveRupeesButton .RupeesSave {
  width: 5rem;
  height: 2rem;
  font-size: 0.875rem;
  padding: 0.25rem;
  border-radius: 0.25rem;
  color: #ffffff;
  background-color: var(--AccentColor);
  display: flex;
  justify-content: center;
  align-items: center;
}
.topBar .WalletModal .SubWalletModal::after {
  position: absolute;
  content: "";
  width: 1rem;
  height: 1rem;
  display: block;
  background: #ffffff;
  top: -1rem;
  left: 50%;
  transform: translateX(-50%);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}
.topBar .CloseOut {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 10;
}
.topBar .NotificationContainer {
  position: absolute;
  width: 30rem;
  padding: 1rem;
  background: var(--Foreground);
  border-radius: 0.5rem;
  box-shadow: 0rem 0rem 0.5rem var(--Stroke);
  right: 0.5rem;
  top: 3.5rem;
  z-index: 11;
  height: calc(100vh - 4rem);
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.topBar .NotificationContainer .NotificationHeader {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 0.0625rem solid var(--Invitation);
}
.topBar .NotificationContainer .NotificationHeader h1 {
  font-size: 1rem;
  font-weight: 700;
  color: var(--TextColor);
  white-space: nowrap;
  flex: 1 1;
}
.topBar .NotificationContainer .NotificationHeader button {
  font-size: 0.75rem;
  white-space: nowrap;
  padding: 0.25rem 0.5rem;
  background: var(--Stroke);
  border-radius: 0.25rem;
  cursor: pointer;
  color: var(--TextColor);
}
.topBar .NotificationContainer .NotificationHeader button:disabled {
  cursor: not-allowed;
}
.topBar .NotificationContainer .NotificationHeader svg {
  min-width: 1.25rem;
  min-height: 1.25rem;
  padding: 0.25rem;
  background: var(--Invitation);
  border-radius: 50%;
  cursor: pointer;
}
.topBar .NotificationContainer .NotificationHeader svg path {
  fill: var(--AccentColor);
}
.topBar .NotificationContainer .AllImportant {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-bottom: 0.0625rem solid var(--Invitation);
}
.topBar .NotificationContainer .AllImportant .AllImp {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.25rem 0.25rem 0.5rem;
  border-radius: 0.25rem;
  border: 0.0625rem solid var(--Invitation);
  cursor: pointer;
}
.topBar .NotificationContainer .AllImportant .AllImp span {
  font-size: 0.75rem;
  color: var(--TextColor);
}
.topBar .NotificationContainer .AllImportant .AllImp span:nth-child(2) {
  font-size: 0.75rem;
  padding: 0.125rem 0.25rem;
  border-radius: 0.125rem;
  background: var(--Invitation);
}
.topBar .NotificationContainer .AllImportant div:hover:not(.Active) {
  background: var(--Pending);
}
.topBar .NotificationContainer .AllImportant .Active {
  background: var(--Invitation);
}
.topBar .NotificationContainer .AllImportant .Active span:nth-child(2) {
  background: var(--Pending);
}
.topBar .NotificationContainer .NotificationsSection {
  width: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 0.75rem;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList h3 {
  font-size: 0.75rem;
  color: var(--TextColor);
  font-weight: 500;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 0.0625rem solid var(--Foreground);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  background: var(--Background);
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .Icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 50%;
  background: var(--Invitation);
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .Icon svg {
  height: 1.5rem;
  width: 1.5rem;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .Icon svg path {
  fill: var(--AccentColor);
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .TitleContent {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .TitleContent h3 {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--TextColor);
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .TitleContent span {
  font-size: 0.625rem;
  color: var(--TextColor);
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .CTATime {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .CTATime span {
  color: #9b9b9b;
  font-size: 0.625rem;
  font-weight: 500;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .CTATime .CTA {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .CTATime .CTA button {
  width: 6rem;
  height: 1.5rem;
  border-radius: 0.25rem;
  background: var(--AccentColor);
  border: none;
  color: #ffffff;
  font-size: 0.625rem;
  cursor: pointer;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .CTATime .CTA .Delete {
  height: 1.5rem;
  width: 1.5rem;
  display: grid;
  place-items: center;
  background: var(--Background);
  border-radius: 0.25rem;
  cursor: pointer;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .CTATime .CTA .Delete svg {
  height: 0.75rem;
  width: 0.75rem;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .Notification .CTATime .CTA .DontAllow {
  background: var(--Foreground);
  opacity: 0.2;
  cursor: not-allowed;
}
.topBar .NotificationContainer .NotificationsSection .NotificationList .ReadByUser {
  background: var(--Foreground);
  border: 0.0625rem solid var(--Invitation);
}
.topBar .ClickOut {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}

@media (max-width: 650px) {
  .topBar h1 {
    font-size: 1.25rem;
  }
  .topBar .searchBar .HalfLogo {
    display: block;
  }
  .topBar .searchBar .FullLogo {
    display: none;
  }
}
@media (max-width: 450px) {
  .topBar h1 {
    cursor: pointer;
  }
  .topBar .SideBarIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
@keyframes move-up {
  from {
    transform: translate(4px, 8px);
  }
  to {
    transform: translate(0, 0);
  }
}
@keyframes move-down {
  from {
    transform: translate(-4px, -8px);
  }
  to {
    transform: translate(0, 0);
  }
}
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Topbar/Topbar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EAEE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAEJ;AAAI;EAEE,8BAAA;AACN;AAEE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;AAAJ;AACI;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,sCAAA;EACA,6CAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AACN;AACI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACN;AAAM;EACE,+BAAA;EACA,eAAA;EACA,kBAAA;AAER;AAAM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;AAER;AADQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAGV;AADQ;EACE,iBAAA;AAGV;AADQ;EACE,oCAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AAGV;AADQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mCAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AAGV;AADQ;EACE,iBAAA;EACA,gBAAA;AAGV;AADQ;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;AAGV;AAAM;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;AAER;AADQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uCAAA;EACA,iBAAA;EACA,YAAA;EAEA,cAAA;AAEV;AADU;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAGZ;AADU;EACE,yBAAA;AAGZ;AADU;EACE,eAAA;AAGZ;AAEU;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AAAZ;AACY;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;AACd;AACY;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,sCAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AACd;AAEU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,6BAAA;EACA,uBAAA;AAAZ;AACY;EACE,sBAAA;EACA,mCAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AACd;AACY;EACE,sBAAA;EACA,oCAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AACd;AAAc;EACE,mBAAA;AAEhB;AAME;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;AAJJ;AAKI;EACE,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,MAAA;EAEA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAJN;AAOE;EACE,aAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;UAAA,iBAAA;AALJ;AAOE;EACE,cAAA;EACA,uBAAA;EACA,iBAAA;AALJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;AALJ;AAMI;EACE,mCAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EAeA,uBAAA;AAlBN;AAIM;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAFR;AAIM;EACE,mBAAA;AAFR;AAIM;EACE,cAAA;AAFR;AAKM;EACE,kBAAA;EACA,yBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,mCAAA;EAEA,wCAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AAJR;AAKQ;EACE,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,sCAAA;AAHV;AAKQ;EACE,8BAAA;AAHV;AAOI;EACE,aAAA;AALN;AASE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;AAPJ;AAQI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;AAPN;AAQM;EACE,aAAA;EACA,eAAA;EACA,WAAA;AANR;AAOQ;EACE,cAAA;AALV;AAMU;EAEE,aAAA;EACA,mBAAA;EACA,gBAAA;AALZ;AAMY;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AAJd;AAOU;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AALZ;AAMY;EACE,gBAAA;EACA,iBAAA;AAJd;AAQQ;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AANV;AAOU;EACE,aAAA;EACA,sBAAA;EAEA,uBAAA;EACA,mBAAA;AANZ;AAOY;EACE,YAAA;EACA,eAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AALd;AAOY;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AALd;AAMc;EACE,yBAAA;EACA,iBAAA;AAJhB;AAUM;EACE,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,iBAAA;AARR;AAaU;EACE,kBAAA;EACA,gBAAA;AAXZ;AAaU;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AAXZ;AAcQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAZV;AAaU;EACE,kBAAA;EACA,gBAAA;AAXZ;AAiBQ;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAfV;AAgBU;EAEE,eAAA;EACA,yCAAA;EACA,uBAAA;EACA,aAAA;AAfZ;AAgBY;EACE,WAAA;EACA,YAAA;EACA,gDAAA;AAdd;AAiBU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAfZ;AAgBY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,sBAAA;AAdd;AAgBY;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAdd;AAmBM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,8CAAA;AAjBR;AAsBE;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AApBJ;AAuBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,qBAAA;EACA,0CAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AArBJ;AAuBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,gDAAA;AArBN;AAuBM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AArBR;AAwBM;EACE,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,uBAAA;AAtBR;AAwBM;EACE,mBAAA;AAtBR;AAyBM;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;AAvBR;AAwBQ;EACE,wBAAA;AAtBV;AA2BI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,gDAAA;AAzBN;AA2BM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uCAAA;EACA,sBAAA;EACA,yCAAA;EACA,eAAA;AAzBR;AA2BQ;EACE,kBAAA;EACA,uBAAA;AAzBV;AA4BQ;EACE,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;AA1BV;AA8BM;EACE,0BAAA;AA5BR;AA+BM;EACE,6BAAA;AA7BR;AA+BQ;EACE,0BAAA;AA7BV;AAkCI;EACE,WAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AAhCN;AAiCM;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;AA/BR;AAgCQ;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;AA9BV;AAiCQ;EACE,WAAA;EACA,uBAAA;EACA,yCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AA/BV;AAgCU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;AA9BZ;AAgCY;EACE,cAAA;EACA,aAAA;AA9Bd;AA+Bc;EACE,wBAAA;AA7BhB;AAkCU;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AAhCZ;AAkCY;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AAhCd;AAmCY;EACE,mBAAA;EACA,uBAAA;AAjCd;AAqCU;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;AAnCZ;AAqCY;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AAnCd;AAsCY;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AApCd;AAsCc;EACE,WAAA;EACA,cAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AApChB;AAuCc;EACE,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;AArChB;AAuCgB;EACE,eAAA;EACA,cAAA;AArClB;AAwCc;EACE,6BAAA;EACA,YAAA;EACA,mBAAA;AAtChB;AA2CQ;EACE,6BAAA;EACA,yCAAA;AAzCV;AA8CE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AA5CJ;;AAgDA;EAEI;IACE,kBAAA;EA9CJ;EAiDI;IACE,cAAA;EA/CN;EAiDI;IACE,aAAA;EA/CN;AACF;AAoDA;EAEI;IACE,eAAA;EAnDJ;EAqDE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;EAnDJ;AACF;AAuDA;EACE;IACE,8BAAA;EArDF;EAuDA;IACE,0BAAA;EArDF;AACF;AAwDA;EACE;IACE,gCAAA;EAtDF;EAwDA;IACE,0BAAA;EAtDF;AACF;AAyDA;EACE;IACE,UAAA;EAvDF;EAyDA;IACE,UAAA;EAvDF;AACF","sourcesContent":[".topBar {\n  // height: 5%;\n  padding: 0.25rem 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  .walletDetails {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    padding: 0.25rem 0.5rem;\n    border-radius: 8px;\n    border: 1px solid var(--Stroke);\n    color: var(--TextColor);\n    cursor: pointer;\n    position: relative;\n\n    &:hover,\n    &.Active {\n      background-color: var(--Hover);\n    }\n  }\n  .walletDetailsContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    position: absolute;\n    top: 4rem;\n    right: 5rem;\n    background-color: var(--Foreground);\n    z-index: 11;\n    width: max-content;\n    border-radius: 1rem;\n    padding: 1rem;\n    box-shadow: 0rem 0rem 0.5rem var(--Stroke);\n    &:after {\n      content: \"\";\n      display: inline-block;\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-left: 0.8rem solid transparent;\n      border-right: 0.8rem solid transparent;\n      border-bottom: 1.2rem solid var(--Foreground);\n      top: -1rem;\n      right: 40%;\n      z-index: 10;\n    }\n    .section {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 4rem;\n      &.Active {\n        border: 1px solid var(--Stroke);\n        padding: 0.5rem;\n        border-radius: 8px;\n      }\n      .subSection {\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n        color: var(--TextColor);\n        .walletDetailsTitle {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          font-size: 0.8rem;\n          font-weight: 600;\n        }\n        .walletBalance {\n          font-size: 1.6rem;\n        }\n        .walletBtnPrimary {\n          background-color: var(--AccentColor);\n          color: #ffffff;\n          padding: 0.5rem 1.5rem;\n          border-radius: 8px;\n        }\n        .walletBtnSecondary {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          background-color: var(--Background);\n          color: var(--TextColor);\n          padding: 0.5rem 1.5rem;\n          border-radius: 8px;\n        }\n        .balanceTitle {\n          font-size: 0.8rem;\n          font-weight: 600;\n        }\n        .balanceMessage {\n          font-size: 0.6rem;\n          color: var(--TextColor);\n          opacity: 0.8;\n        }\n      }\n      .balanceContainer {\n        display: flex;\n        flex-direction: column;\n        gap: 0.2rem;\n        color: var(--TextColor);\n        .lowBalanceNonEdit {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          padding: 0.125rem 1rem 0.125rem 0.25rem;\n          font-size: 1.4rem;\n          width: 10rem;\n          // padding-left: 1rem;\n          height: 1.8rem;\n          .balance {\n            max-width: 8rem;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n          &.Active {\n            animation: move-down 0.2s;\n          }\n          svg {\n            cursor: pointer;\n          }\n        }\n        .lowBalanceForm {\n          // flex-direction: column;\n          .lowBalanceInputWrapper {\n            position: relative;\n            font-size: 1.4rem;\n            width: 10rem;\n            animation: move-up 0.2s;\n            &::after {\n              content: \"₹\";\n              position: absolute;\n              top: 0;\n              left: 0;\n              top: 50%;\n              transform: translateY(-50%);\n            }\n            .lowBalanceInput {\n              width: inherit;\n              padding-left: 1rem;\n              background: none;\n              border: none;\n              border-bottom: 0.0625rem solid #9b9b9b;\n              border-radius: none;\n              position: relative;\n              color: var(--TextColor);\n              font-size: inherit;\n              font-family: inherit;\n            }\n          }\n          .lowBalanceButtonWrapper {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 0.5rem;\n            transform: translateY(0.3rem);\n            animation: fade-in 0.2s;\n            .cancelBtn {\n              padding: 0.2rem 0.8rem;\n              background-color: var(--Invitation);\n              color: var(--TextColor);\n              font-size: 0.8rem;\n              border-radius: 4px;\n            }\n            .saveBtn {\n              padding: 0.2rem 0.8rem;\n              background-color: var(--AccentColor);\n              color: #ffffff;\n              font-size: 0.8rem;\n              border-radius: 4px;\n              .loading {\n                padding: 1px 0.5rem;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  .notificationSvg {\n    position: relative;\n    width: max-content;\n    height: max-content;\n    div {\n      position: absolute;\n      padding: 0.25rem;\n      background-color: rgb(246, 40, 40);\n      top: 0;\n      // outline: .5px solid var(--Foreground);\n      right: 50%;\n      font-size: 0.5rem;\n      width: 1.25rem;\n      height: 1.25rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: white;\n      border-radius: 50%;\n    }\n  }\n  .SideBarIcon {\n    display: none;\n    width: 2.5rem;\n    height: 2.5rem;\n    min-width: 2rem;\n    min-height: 2rem;\n    border-radius: 50%;\n    background: var(--Foreground);\n    font-size: 1.5rem;\n    font-weight: 1000;\n    color: var(--TextColor);\n    user-select: none;\n  }\n  h1 {\n    flex: 1 10rem 8rem;\n    color: var(--TextColor);\n    font-size: 1.5rem;\n  }\n  .searchBar {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap-reverse;\n    justify-content: flex-end;\n    gap: 0.9rem;\n    .searchBarForm {\n      background-color: var(--Foreground);\n      border-radius: 1.25rem;\n      height: 2.25rem;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 0.6rem;\n      padding: 0 0.75rem;\n      position: relative;\n      input {\n        background-color: transparent;\n        height: 100%;\n        outline: none;\n        border: none;\n        color: var(--TextColor);\n        font-size: 0.875rem;\n      }\n      svg {\n        margin-top: 0.25rem;\n      }\n      input::placeholder {\n        color: #696969;\n      }\n      /* Dropdown container */\n      .search-dropdown {\n        position: absolute;\n        top: calc(100% + 0.25rem);\n        left: 0;\n        right: 0;\n        padding: 0.5rem;\n        background-color: var(--Foreground);\n        // border: 0.0625rem solid var(--Stroke);\n        box-shadow: 0 0 2rem 0 var(--Background);\n        border-radius: 1rem;\n        list-style-type: none;\n        display: flex;\n        flex-direction: column;\n        gap: 0.25rem;\n        max-height: 20rem;\n        overflow: auto;\n        z-index: 1000;\n        .dropdown-item {\n          padding: 0.25rem 0.75rem;\n          min-height: 2rem;\n          display: flex;\n          align-items: center;\n          border-radius: 0.5rem;\n          font-size: 0.75rem;\n          cursor: pointer;\n          color: var(--TextColor);\n          transition: background-color 0.2s ease;\n        }\n        .dropdown-item:hover {\n          background-color: var(--Hover);\n        }\n      }\n    }\n    .HalfLogo {\n      display: none;\n    }\n  }\n\n  .WalletModal {\n    position: absolute;\n    top: -1rem;\n    right: -14rem;\n    z-index: 11;\n    display: flex;\n    justify-content: flex-end;\n    .SubWalletModal {\n      position: relative;\n      top: 4rem;\n      right: 3rem;\n      // width: 25rem;\n      height: max-content;\n      background: white;\n      border-radius: 0.625rem;\n      padding: 0.5rem;\n      border: 0.025rem solid var(--Stroke);\n      display: flex;\n      flex-direction: column;\n      .WalletImgMain {\n        display: flex;\n        padding: 0.5rem;\n        gap: 0.5rem;\n        .WalletImage {\n          width: 12.5rem;\n          .WalletImg {\n            // background: aqua;\n            display: flex;\n            align-items: center;\n            padding: 0.25rem;\n            .yourwallet {\n              font-size: 1rem;\n              font-weight: 700;\n              padding-left: 0.5rem;\n            }\n          }\n          .WalletRupees {\n            display: flex;\n            align-items: center;\n            margin-top: 0.5rem;\n            .WalletNum {\n              font-weight: 700;\n              font-size: 1.5rem;\n            }\n          }\n        }\n        .WalletMainButton {\n          background-color: #cb1c1c;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          background-color: white;\n          width: 12.5rem;\n          .WalletButton {\n            display: flex;\n            flex-direction: column;\n            // background-color: #9B9B9B;\n            justify-content: center;\n            align-items: center;\n            .RechargeButton {\n              width: 10rem;\n              padding: 0.5rem;\n              background: var(--AccentColor);\n              color: #ffffff;\n              font-size: 0.8rem;\n              border-radius: 0.25rem;\n            }\n            .MoreImg {\n              width: 10rem;\n              padding: 0.25rem;\n              display: flex;\n              background: #f4f3f8;\n              justify-content: center;\n              align-items: center;\n              margin-top: 0.5rem;\n              border-radius: 0.25rem;\n              gap: 0.25rem;\n              .More {\n                color: var(--AccentColor);\n                font-size: 0.8rem;\n              }\n            }\n          }\n        }\n      }\n      .LowBalanceMain {\n        display: flex;\n        border: 0.0625rem solid var(--Stroke);\n        border-radius: 0.625rem;\n        padding: 0.625rem;\n        .LowBalance {\n          // width: 15rem;\n          // height: 6rem;\n          // background-color: #cb1c1c;\n          .LowBalanceAlert {\n            font-size: 1.25rem;\n            font-weight: 700;\n          }\n          .FundBalance {\n            font-size: 0.75rem;\n            color: #9b9b9b;\n            text-wrap: balance;\n          }\n        }\n        .LowRupees {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          .LowAlertRupees {\n            font-size: 1.75rem;\n            font-weight: 700;\n          }\n          // svg {\n          //   padding: 1rem;\n          // }\n        }\n        .LowRupeesInput {\n          display: flex;\n          flex-direction: column;\n          gap: 0.5rem;\n          .RupeesInput {\n            // background-color: #696969;\n            padding: 0.5rem;\n            border: 0.0625rem solid var(--Invitation);\n            border-radius: 0.625rem;\n            display: flex;\n            input {\n              width: 100%;\n              border: none;\n              border-bottom: 0.0625rem solid var(--Invitation);\n            }\n          }\n          .SaveRupeesButton {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            gap: 0.5rem;\n            .RupeesCancel {\n              width: 5rem;\n              height: 2rem;\n              font-size: 0.875rem;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              background-color: var(--Invitation);\n              padding: 0.25rem;\n              border-radius: 0.25rem;\n            }\n            .RupeesSave {\n              width: 5rem;\n              height: 2rem;\n              font-size: 0.875rem;\n              padding: 0.25rem;\n              border-radius: 0.25rem;\n              color: #ffffff;\n              background-color: var(--AccentColor);\n              display: flex;\n              justify-content: center;\n              align-items: center;\n            }\n          }\n        }\n      }\n      &::after {\n        position: absolute;\n        content: \"\";\n        width: 1rem;\n        height: 1rem;\n        display: block;\n        background: #ffffff;\n        top: -1rem;\n        left: 50%;\n        transform: translateX(-50%);\n        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n      }\n    }\n  }\n\n  .CloseOut {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    z-index: 10;\n  }\n\n  .NotificationContainer {\n    position: absolute;\n    width: 30rem;\n    padding: 1rem;\n    background: var(--Foreground);\n    border-radius: 0.5rem;\n    box-shadow: 0rem 0rem 0.5rem var(--Stroke);\n    right: 0.5rem;\n    top: 3.5rem;\n    z-index: 11;\n    height: calc(100vh - 4rem);\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n\n    .NotificationHeader {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n      padding-bottom: 0.5rem;\n      border-bottom: 0.0625rem solid var(--Invitation);\n\n      h1 {\n        font-size: 1rem;\n        font-weight: 700;\n        color: var(--TextColor);\n        white-space: nowrap;\n        flex: 1;\n      }\n\n      button {\n        font-size: 0.75rem;\n        white-space: nowrap;\n        padding: 0.25rem 0.5rem;\n        background: var(--Stroke);\n        border-radius: 0.25rem;\n        cursor: pointer;\n        color: var(--TextColor);\n      }\n      button:disabled {\n        cursor: not-allowed;\n      }\n\n      svg {\n        min-width: 1.25rem;\n        min-height: 1.25rem;\n        padding: 0.25rem;\n        background: var(--Invitation);\n        border-radius: 50%;\n        cursor: pointer;\n        path {\n          fill: var(--AccentColor);\n        }\n      }\n    }\n\n    .AllImportant {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      gap: 0.75rem;\n      padding: 0.5rem 0;\n      border-bottom: 0.0625rem solid var(--Invitation);\n\n      .AllImp {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        padding: 0.25rem 0.25rem 0.25rem 0.5rem;\n        border-radius: 0.25rem;\n        border: 0.0625rem solid var(--Invitation);\n        cursor: pointer;\n\n        span {\n          font-size: 0.75rem;\n          color: var(--TextColor);\n        }\n\n        span:nth-child(2) {\n          font-size: 0.75rem;\n          padding: 0.125rem 0.25rem;\n          border-radius: 0.125rem;\n          background: var(--Invitation);\n        }\n      }\n\n      div:hover:not(.Active) {\n        background: var(--Pending);\n      }\n\n      .Active {\n        background: var(--Invitation);\n\n        span:nth-child(2) {\n          background: var(--Pending);\n        }\n      }\n    }\n\n    .NotificationsSection {\n      width: 100%;\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      overflow: auto;\n      .NotificationList {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 0.75rem;\n        padding-top: 0.75rem;\n        h3 {\n          font-size: 0.75rem;\n          color: var(--TextColor);\n          font-weight: 500;\n        }\n\n        .Notification {\n          width: 100%;\n          padding: 0.5rem 0.75rem;\n          border: 0.0625rem solid var(--Foreground);\n          border-radius: 0.5rem;\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          gap: 0.75rem;\n          background: var(--Background);\n          .Icon {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            padding: 0.5rem;\n            border-radius: 50%;\n            background: var(--Invitation);\n\n            svg {\n              height: 1.5rem;\n              width: 1.5rem;\n              path {\n                fill: var(--AccentColor);\n              }\n            }\n          }\n\n          .TitleContent {\n            display: flex;\n            flex-direction: column;\n            gap: 0.25rem;\n            flex: 1;\n\n            h3 {\n              font-size: 0.75rem;\n              font-weight: 600;\n              color: var(--TextColor);\n            }\n\n            span {\n              font-size: 0.625rem;\n              color: var(--TextColor);\n            }\n          }\n\n          .CTATime {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-end;\n            gap: 0.5rem;\n\n            span {\n              color: #9b9b9b;\n              font-size: 0.625rem;\n              font-weight: 500;\n            }\n\n            .CTA {\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              gap: 0.5rem;\n\n              button {\n                width: 6rem;\n                height: 1.5rem;\n                border-radius: 0.25rem;\n                background: var(--AccentColor);\n                border: none;\n                color: #ffffff;\n                font-size: 0.625rem;\n                cursor: pointer;\n              }\n\n              .Delete {\n                height: 1.5rem;\n                width: 1.5rem;\n                display: grid;\n                place-items: center;\n                background: var(--Background);\n                border-radius: 0.25rem;\n                cursor: pointer;\n\n                svg {\n                  height: 0.75rem;\n                  width: 0.75rem;\n                }\n              }\n              .DontAllow {\n                background: var(--Foreground);\n                opacity: 0.2;\n                cursor: not-allowed;\n              }\n            }\n          }\n        }\n        .ReadByUser {\n          background: var(--Foreground);\n          border: 0.0625rem solid var(--Invitation);\n        }\n      }\n    }\n  }\n  .ClickOut {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    z-index: 10;\n  }\n}\n\n@media (max-width: 650px) {\n  .topBar {\n    h1 {\n      font-size: 1.25rem;\n    }\n    .searchBar {\n      .HalfLogo {\n        display: block;\n      }\n      .FullLogo {\n        display: none;\n      }\n    }\n  }\n}\n\n@media (max-width: 450px) {\n  .topBar {\n    h1 {\n      cursor: pointer;\n    }\n    .SideBarIcon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n    }\n  }\n}\n\n@keyframes move-up {\n  from {\n    transform: translate(4px, 8px);\n  }\n  to {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes move-down {\n  from {\n    transform: translate(-4px, -8px);\n  }\n  to {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
